import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXTranslationModule, AXTranslationService } from '@acorex/core/translation';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SettingDataOutputModel } from '@travel/shared';
import { DataConfig, PlatformService } from '@travel/shared/services';

@Component({
  selector: 'travel-btc-workspace-hotel-wl-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, AXDecoratorModule, AXTranslationModule],
  templateUrl: './hotel-wl-footer.component.html',
  styleUrls: ['./hotel-wl-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HotelWlFooterComponent implements OnInit {
  protected translateService = inject(AXTranslationService);

  version = this.appVersion;
  language = '';

  socialMediaList: any[] = [];
  nemadList: any[] = [];

  env: string = this.environment.picturesURL;

  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  constructor(
    protected _platfromService: PlatformService,
    @Inject('environment') private environment: any,
    @Inject('appVersion') private appVersion: any,
    private _router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.socialMediaList = this.settingData.socialMedia ? JSON.parse(this.settingData.socialMedia) : [];
    this.nemadList = this.settingData.nemad ? JSON.parse(this.settingData.nemad) : [];
  }

  hotels: any[] = [
    {
      // title: 'رزرو هتل های مشهد نزدیک حرم',
      title: this.translateService.translateSync('footer.mashhadHotel'),
      // link: 'hotels/هتل-های-مشهد-نزدیک-حرم'
      link: 'hotels/' + this.translateService.translateSync('city.hotelsUrl') + 'مشهد-نزدیک-حرم',
    },
    {
      // title: 'رزرو هتل های کیش',
      title: this.translateService.translateSync('footer.kishHotel'),
      //  link: this._platfromService.siteLanguage() + '/hotels/هتل-های-کیش'
      link: this._platfromService.siteLanguage() + '/hotels/' + this.translateService.translateSync('city.hotelsUrl') + this.translateService.translateSync('city.kish'),
    },
    {
      // title: 'رزرو هتل های اصفهان',
      title: this.translateService.translateSync('footer.esfahanHotels'),
      // link: this._platfromService.siteLanguage() + '/hotels/هتل-های-اصفهان'
      link: this._platfromService.siteLanguage() + '/hotels/' + this.translateService.translateSync('city.hotelsUrl') + this.translateService.translateSync('city.esfahan'),
    },
    {
      // title: 'رزرو هتل های تهران',
      title: this.translateService.translateSync('footer.tehranHotels'),
      // link: this._platfromService.siteLanguage() + '/hotels/هتل-های-تهران'
      link: this._platfromService.siteLanguage() + '/hotels/' + this.translateService.translateSync('city.hotelsUrl') + this.translateService.translateSync('city.terhran'),
    },
    {
      // title: 'رزرو هتل های بندرعباس',
      title: this.translateService.translateSync('footer.bandarHotels'),
      //  link: this._platfromService.siteLanguage() + '/hotels/هتل-های-بندرعباس'
      link: this._platfromService.siteLanguage() + '/hotels/' + this.translateService.translateSync('city.hotelsUrl') + 'بندرعباس',
    },
  ];

  goToUrl() {
    if (this.settingData.baseUrl) {
      const externalUrl = this.settingData.baseUrl.startsWith('htttp') ? this.settingData.baseUrl : `http://${this.settingData.baseUrl}`;
      this.document.location.href = externalUrl;
    } else {
      this._router.navigate(['/' + this._platfromService.siteLanguage()]);
    }
  }
}
